
      import Select from './select.vue'
      import type { App, Plugin } from 'vue'

      export const SelectPlugin: Plugin = {
        install(app: App) {
          app.component('Select', Select)
        },
      }
      export { Select }
      